import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { NonAuthRoutes, Modules } from '../../../enums';
import { AuthContext } from '../../../contexts/AuthContext';
import { redirectBasedOnPermission } from '../../../utils/methods';
import Brand from './Brand';
import LoginIllustrations from './LoginIllustration';
import ForgotPasswordIllustrations from './ForgotPasswordIllustrations';
import ResetPasswordIllustrations from './ResetPasswordIllustrations';

interface PublicLayoutProps {
  route: NonAuthRoutes;
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ route, children }) => {
  const { token, permissions, isSystemAdmin } = useContext(AuthContext);

  if (token) {
    return (
      <Navigate
        replace
        to={{
          pathname:
            redirectBasedOnPermission(isSystemAdmin, permissions) ||
            Modules.error + NonAuthRoutes.forbidden,
        }}
      />
    );
  }

  let illustration;
  if (route === NonAuthRoutes.login) {
    illustration = <LoginIllustrations />;
  } else if (route === NonAuthRoutes.forgotPassword) {
    illustration = <ForgotPasswordIllustrations />;
  } else if (route === NonAuthRoutes.resetPassword) {
    illustration = <ResetPasswordIllustrations />;
  }

  return (
    <main className="login-main">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner py-4">
          <div className="card">
            <div className="card-body">
              <div className="app-brand justify-content-center mt-5 mb-5">
                <Brand />
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PublicLayout;
